/* user agent helpers */
/* eslint-disable */
export const isUserAgentMobile = () => {
    let check = false;
    if (!navigator) {
        return check;
    }
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
/* eslint-enable */

/* string helpers */
export const upperCaseMatch = (string, searchTerm) => {
    const s = Number.isInteger(string) ? string.toString() : string;

    if (s && s.toUpperCase) {
        return s.toUpperCase().indexOf(searchTerm) !== -1;
    }

    return false;
};

const stringStrengthTests = {
    digits: /\d/,
    uppercase: /[A-ZÄÅÂÆÉÈÊËÏÓÒÔÖØÜ]/u,
    lowercase: /[a-zäåâæéèêëïóòôöøü]/u,
    special: /[^a-zäåâæéèêëïóòôöøüA-ZÄÅÂÆÉÈÊËÏÓÒÔÖØÜ0-9_\s]/u
};

export function getStringStrength(string) {
    let totalScore = 0;
    const testScores = {
        diffChars: 0,
        length: 0,
        digits: 0,
        uppercase: 0,
        lowercase: 0,
        special: 0
    };
    if (string && string.length) {
        const chars = {};
        for (let i = 0; i < string.length; i++) {
            if (!chars[string[i]]) {
                chars[string[i]] = true;
                testScores.diffChars++;
            }
            for (const key in stringStrengthTests) {
                if (stringStrengthTests[key].test(string[i])) {
                    testScores[key]++;
                }
            }
        }
        testScores.length = string.length;
        /* total calculation */
        totalScore = testScores.diffChars
            + testScores.digits
            + (testScores.uppercase * 2)
            + testScores.lowercase
            + (testScores.special * 2);

        /* bonuses */
        let bonusSum = 0;
        for (const key in testScores) {
            let minValue = 0;
            if (key === 'diffChars') {
                minValue = 4;
            }
            if (key === 'length') {
                minValue = 7;
            }
            if (testScores[key] > minValue) {
                bonusSum++;
                totalScore += bonusSum * 5;
            }
        }
    }

    testScores.totalScore = totalScore;

    return testScores;
}

/* object helpers */
export function getObjectProp(obj, prop) {
    if (!obj) { return obj; }
    const property = prop.split('.');
    let value = obj;

    for (let i = 0; i < property.length; i++) {
        if (value) {
            value = value[property[i]];
        } else {
            value = undefined;
            break;
        }
    }
    return value !== undefined ? value : obj[prop];
}

export function setObjectProp(obj, prop, value) {
    const property = prop.split('.');
    let key = obj;

    for (let i = 0; i < property.length; i++) {
        if (i === property.length - 1) {
            key[property[i]] = value;
        } else {
            key = key[property[i]];
        }
    }
}

export function getOrExecProp(obj, prop, ...args) {
    if (prop !== undefined) {
        if (typeof prop === 'function') {
            return prop(obj, ...args);
        }
        if (typeof prop === 'string') {
            const objectProp = getObjectProp(obj, prop);
            if (objectProp !== undefined) {
                return objectProp;
            }
        }
        return prop;
    }
    return null;
}

export function objLength(obj) {
    let count = 0;
    // eslint-disable-next-line
    for (const key in obj) {
        count++;
    }

    return count;
}

export function getConvertedObject(obj, propTypes) {
    const convertedObject = { ...obj };
    Object.keys(propTypes).forEach((key) => {
        if (obj[key]) {
            if (propTypes[key] === 'integer') {
                convertedObject[key] = parseInt(obj[key], 10);
            } else if (propTypes[key] === 'float') {
                convertedObject[key] = parseFloat(obj[key]);
            }
            if (propTypes[key] === 'integer' || propTypes[key] === 'float') {
                if (isNaN(convertedObject[key])) {
                    convertedObject[key] = null;
                }
            }
        }
    });
    return convertedObject;
}

/* number helpers */
export function roundNumber(value, decimals) {
    if (typeof value === 'number' && value === 0) {
        return 0;
    }
    const multiplier = decimals ? 10 ** decimals : 1;
    return typeof value === 'number' ? Math.round(value * multiplier) / multiplier : null;
}

const thousandsRegex = /\d(?=(?:\d{3})+(?:\.|$))/g;
export function formatNumber(value, decimals = 1, showPlus = false, commaSeparator = '.', thousandsSeparator = ' ') {
    if (typeof value !== 'number') {
        return value;
    }
    const n = String(value.toFixed(decimals));
    const p = n.indexOf('.');
    let formattedNumber = n.replace(
        thousandsRegex,
        (m, i) => { return p < 0 || i < p ? `${m}${thousandsSeparator}` : m; }
    );

    if (commaSeparator !== '.') {
        formattedNumber = formattedNumber.replace('.', commaSeparator);
    }

    return value > 0 && showPlus ? `+${formattedNumber}` : formattedNumber;
}

export function padNumber(num, digits) {
    let res = `${num}`;
    let count = res.length;
    while (count < digits) {
        res = `0${res}`;
        count++;
    }
    return res;
}

const ordinalSuffixes = ['th', 'st', 'nd', 'rd'];
export function getOrdinal(number, prefixWithNum = true) {
    const v = Math.abs(number) % 100;
    const suffix = ordinalSuffixes[(v - 20) % 10] || ordinalSuffixes[v] || ordinalSuffixes[0];
    return prefixWithNum ? `${number}${suffix}` : suffix;
}

export function isBetween(x, min, max, minIncluded = true, maxIncluded = false) {
    return (minIncluded ? x >= min : x > min) && (maxIncluded ? x <= max : x < max);
}

export function isBetweenLimits(x, limits) {
    const minIncluded = limits.charAt(0) === '[';
    const maxIncluded = limits.slice(-1) === ']';
    const limitsArr = limits.slice(1, -1).split(',');
    const min = limitsArr[0] === '-Infinity' ? -Infinity : parseInt(limitsArr[0], 10);
    const max = limitsArr[1] === 'Infinity' ? Infinity : parseInt(limitsArr[1], 10);
    return isBetween(x, min, max, minIncluded, maxIncluded);
}

const greatestCommonDivisor = (x, y) => {
    const a = x >= y ? x : y;
    const b = x >= y ? y : x;
    return b === 0 ? Math.abs(a) : greatestCommonDivisor(b, a % b);
};

export function leastCommonMultiple(x, y) {
    if (x === 0) { return y; }
    if (y === 0) { return x; }
    return (x * y) / greatestCommonDivisor(x, y);
}

/* className helpers */
export function getClassName(...args) {
    let className = '';
    for (let i = 0; i < args.length; i++) {
        if (args[i]) {
            if (typeof args[i] === 'string' || typeof args[i] === 'number') {
                className += ` ${args[i]}`;
            } else if (typeof args[i] === 'object') {
                // eslint-disable-next-line no-loop-func
                const argKeys = Object.keys(args[i]);
                for (let j = 0; j < argKeys.length; j++) {
                    if (args[i][argKeys[j]]) {
                        className += ` ${argKeys[j]}`;
                    }
                }
            }
        }
    }
    return className.trim();
}

/* misc helpers */
export function sortItemsByPropertyName(property, ascending = true) {
    return (aItem, bItem) => {
        const aValue = getObjectProp(aItem, property);
        const bValue = getObjectProp(bItem, property);
        if (aValue !== undefined && bValue !== undefined) {
            const a = typeof aValue === 'string' ? aValue.toUpperCase() : aValue;
            const b = typeof bValue === 'string' ? bValue.toUpperCase() : bValue;
            if (a < b || (a === null && b !== null)) {
                return ascending ? -1 : 1;
            }
            if (a > b || (a !== null && b === null)) {
                return ascending ? 1 : -1;
            }
        }
        return 0;
    };
}

export const setArrayToFormData = (formData, name, value) => {
    value.forEach((item, index) => {
        if (typeof item === 'object') {
            Object.keys(item).forEach((key) => {
                formData.append(`${name}[${index}].${key}`, item[key]);
            });
        } else {
            formData.append(`${name}[${index}]`, item);
        }
    });
};
